import { render, staticRenderFns } from "./ConsentimentoLgpd.vue?vue&type=template&id=7faf9af1"
import script from "./ConsentimentoLgpd.vue?vue&type=script&lang=js"
export * from "./ConsentimentoLgpd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports